define.alias("shared/components/shared/carousel/index", "preview-grid/components/shared/carousel/index");